import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { Roba } from './roba';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-roba-modal-update',
  templateUrl: './roba-modal-update.component.html'
})
export class RobaModalUpdateComponent extends BaseModalUpdateComponent<Roba> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Roba>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
